import React, { useCallback } from 'react';
import SourceProfilesViewPage from './SourceProfilesViewPage';
import { getAdminSourceProfiles } from '../services/adminAnalyticsService';

function AdminProfilesViewPage() {
  const fetchProfiles = useCallback(
    ({ from, to } = {}) => getAdminSourceProfiles({ from, to }),
    [],
  );

  return <SourceProfilesViewPage fetchProfiles={fetchProfiles} />;
}

export default AdminProfilesViewPage;
